import React, { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import useAcceptInvitation from '../../hooks/api/users/useAcceptInvitation';
import { getKreezeeSession } from '../../utilities/LocalStorage';

const AcceptInvitationPage: FC = () => {
  //   const [error, setError] = useState('');
  //   const [isCreateAccount, setIsCreateAccount] = useState(false);
  //   const [loading, setLoading] = useState(false);
  const { invitationId } = useParams<{ invitationId?: string | undefined }>();
  const { acceptInvitation } = useAcceptInvitation();
  const history = useHistory();

  useEffect(() => {
    const session = getKreezeeSession();
    if (session && session.jwt) {
      const activate = async () => {
        if (invitationId) {
          await acceptInvitation(invitationId);
          history.replace('/');
        }
      };
      activate();
    } else {
      history.replace(`/create-account/${invitationId}`);
    }
  }, [invitationId]);

  return (
    <>
      <div className="background"></div>
    </>
  );
};

export default AcceptInvitationPage;
